import React from "react";
import { TableInput } from "components/common/input";
import { CaseDropdown } from "components/cases/detail/caseDropdown";
import { EnumCateogy } from "service/constant/reviewConstant";
import type { IReviewDetail } from "service/interface/review";
import moment from "moment";
import { cls } from "shared/lib/util/classnames";

interface Props {
  data: IReviewDetail;
  setData: React.Dispatch<React.SetStateAction<IReviewDetail>>;
}

export function ReivewInfoTable({ data, setData }: Props) {
  const handleTitleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setData((prev) => ({
      ...prev,
      title: e.target.value,
    }));
  };

  const handleWriterInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setData((prev) => ({
      ...prev,
      writer: e.target.value,
    }));
  };

  const handleReviewedAtInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setData((prev) => ({
      ...prev,
      reviewedAt: e.target.value,
    }));
  };

  const handleScoreInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setData((prev) => ({
      ...prev,
      score: +e.target.value.replace(/[^0-9,]/g, ""),
    }));
  };

  const handleCategory = (id: string) => {
    setData((prev) => ({
      ...prev,
      category: id,
    }));
  };

  const handleContentInput = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setData((prev) => ({
      ...prev,
      content: e.target.value,
    }));
  };

  return (
    <div>
      <div className="mb-[24px] flex items-center justify-between">
        <p className="m-0 text-[24px] font-semibold leading-[30px] text-black">
          리뷰 정보
        </p>
      </div>
      <div className="w-full border-t-[2px] border-t-black p-0">
        <div className="flex h-[86px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            제목
          </div>
          <div className="flex h-full w-[318px] items-center px-[12px] text-M3 text-gray-5">
            <TableInput
              value={data.title}
              onChange={handleTitleInput}
              placeholder="제목을 입력해 주세요"
            />
          </div>
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            리뷰 작성자
          </div>
          <div className="flex h-full w-[318px] items-center px-[12px] text-M3 text-gray-5">
            <TableInput
              value={data.writer}
              onChange={handleWriterInput}
              placeholder="이름을 입력해 주세요"
            />
          </div>
        </div>
        <div className="flex h-[86px] w-full border-b-[1px] border-b-gray-1">
          {data.createdAt && (
            <>
              <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
                생성일
              </div>
              <div className="flex h-full w-[318px] items-center gap-[48px] px-[24px] text-M3 text-gray-5">
                {moment(data.createdAt).format("YYYY-MM-DD")}
              </div>
            </>
          )}
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            리뷰 작성일
          </div>
          <div
            className={cls(
              data.createdAt ? "w-[318px]" : "w-[787px]",
              "flex h-full items-center px-[12px] text-M3 text-gray-5",
            )}
          >
            <TableInput
              value={data.reviewedAt}
              onChange={handleReviewedAtInput}
              placeholder="리뷰 작성일을 입력해 주세요 (ex: YYYY-MM-DD)"
            />
          </div>
        </div>
        <div className="flex h-[86px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            별점
          </div>
          <div className="flex h-full w-[787px] items-center px-[12px] text-M3 text-gray-5">
            <TableInput
              value={data.score ? data.score + "" : ""}
              onChange={handleScoreInput}
              placeholder="n에 들어갈 숫자를 입력해 주세요.(ex: n/5)"
            />
          </div>
        </div>
        <div className="flex h-[86px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            상품명
          </div>
          <div className="flex h-full w-[787px] items-center px-[12px] text-M3 text-gray-5">
            <CaseDropdown
              menuList={[
                {
                  id: "memorialPark",
                  name: "추모공원",
                },
                {
                  id: "funeral",
                  name: "이장∙개장",
                },
                {
                  id: "tombConstruction",
                  name: "묘 조성",
                },
                {
                  id: "landClearing",
                  name: "벌초 대행",
                },
                {
                  id: "inheritance",
                  name: "상속상담",
                },
                {
                  id: "lifeGoods",
                  name: "생전∙유품정리",
                },
                {
                  id: "condolence",
                  name: "상조",
                },
              ]}
              label="상품명"
              selectMenu={EnumCateogy[data.category]}
              onClick={handleCategory}
            />
          </div>
        </div>
        <div className="flex h-[236px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            내용
          </div>
          <div className="flex h-full w-[787px] items-center px-[12px] text-M3 text-gray-5">
            <textarea
              value={data.content}
              onChange={handleContentInput}
              placeholder="내용을 입력해 주세요."
              className="m-0 h-[204px] w-full resize-none rounded-[4px] border-[1px] border-gray-1 bg-[#fafafa] px-[24px] py-[16px] text-M3 text-gray-5 outline-none placeholder:text-[#c6c6c6] focus:border-gray-5 focus:ring-0"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
